import React from 'react';
import Title from '../../../../../@casino/ui/title';
import TableCasino from '../../../../../@casino/ui/table';
import { useDispatch, useSelector } from 'react-redux';
import {getDate} from '../../../../../@casino/lib/getDate';
import { setGetListEvents } from '../../store/thunk/setGetListEvents';

const AdminEvent = () => {
    const dispatch = useDispatch();

    const list_admin = useSelector((state) => state.admin.events);
    
    React.useEffect(() => {
        dispatch(setGetListEvents({
            page: 1,
            rowsPerPage: 10
        }));
    }, [])

    const columns = [
        { id: 'id', label: 'ID'},
        { id: 'event_date', label: 'Дата'},
        { id: 'login', label: 'Логин'},
        { id: 'description', label: 'Событие'},
        { id: 'ip', label: 'IP'}
    ];
  
    const rows = list_admin.data.map((item) => {
        return {
            id: item.id,
            event_date: getDate(item.event_date),
            login: item.login,
            description: item.description,
            ip: item.ip
        }
    })

    return (
        <div style={{padding: 20, paddingTop: 0}}>
            <Title label="История действий" />
            <div style={{
                padding: 20, 
                background: '#1b2039', 
                borderRadius: 8, 
            }}>
                <TableCasino
                    width={1600}
                    pagination
                    allPage={list_admin.countPage}
                    perPage={10}
                    columns={columns}
                    rows={rows}
                    changePage={(v) => dispatch(setGetListEvents({
                        page: +v.page+1,
                        rowsPerPage: v.rowsPerPage
                    }))}
                    changeRowsPerPage={(v) => dispatch(setGetListEvents({
                        page: +v.page + 1,
                        rowsPerPage: v.rowsPerPage
                    }))}
                />
            </div>
        </div>
    )
}

export default AdminEvent;